export default {
  text: 'Avaa {{paymentGateway}}-profiili',
  text_generic: 'Avaa käyttöönottoprofiili',
  toasts: {
    failed_to_create: '{{paymentGateway}}-profiilin avaaminen epäonnistui',
    link_copied: 'Linkki kopioitu leikepöydälle',
    copy_failed: 'Linkin kopiointi epäonnistui',
  },
};
